module.exports = __webpack_public_path__ + "img/bg.035abeca.png";